import { Typography, XIconButton } from '@capsule/consumer-design-system';

import { MedicationChipContent, MedicationSVG } from './styles';

export interface MedicationTileProps {
  title: string;
  onClick: () => void;
}

export const MedicationChip = ({ title, onClick }: MedicationTileProps) => {
  return (
    <>
      <MedicationSVG />
      <MedicationChipContent>
        <Typography variant="body">{title}</Typography>
        <XIconButton helperText="dismiss medication" onClick={onClick} />
      </MedicationChipContent>
    </>
  );
};
